module.exports = __webpack_public_path__ + "img/gc.3a8c5fe8.svg";